import { Grid, styled } from '@mui/material';
import { FIXED_FOOTER_HEIGHT } from 'src/constants';

export const Container = styled(Grid)`
  max-height: calc(60vh - ${FIXED_FOOTER_HEIGHT}px);
  overflow-x: scroll;
`;
